import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject, combineLatest, map, startWith } from 'rxjs';
import { CmsService } from '../../core/services/cms.service';
import { LogCategory, LogType, LogWidget, LoggerService } from '../../core/services/logger.service';
import { ProfileService } from '../../core/services/profile.service';
import { TagManagerService } from '../../core/services/tag-manager.service';
import { ProfileSetting } from '../../pages/profile/profile.component';
import { LoadingWrapper } from '../../shared/loadingwrapper';
import { IWidgetComponent } from '../../shared/widget/i-widget-component';
import { Widget } from '../../shared/widget/widget';

@Component({
    selector: 'app-my-links',
    templateUrl: './my-links.component.html',
    styleUrls: ['./my-links.component.scss'],
    standalone: false
})
export class MyLinksComponent implements OnInit, OnDestroy, AfterViewInit, IWidgetComponent {
    public data: Widget;
    public isActive: boolean = false;
    public tags: string[] = [];
    public links: LoadingWrapper<any>;
    public isExpanded: number[] = [];
    public filterText$: Subject<string> = new Subject<string>();
    public filteredLinks$: Observable<any>;

    constructor(
        private logger: LoggerService,
        public cms: CmsService,
        private gtm: TagManagerService,
        private changeDetector: ChangeDetectorRef,
        public profileService: ProfileService
    ) {
        this.log("constructor", null, LogCategory.Constructor);
    }

    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Widget, LogWidget.MyLinks, category);
    }

    public ngOnInit() {
        this.log("ngOnInit", null, LogCategory.Init);
        this.links = new LoadingWrapper(this.cms.getV2ContentByType$("Links"));

        this.filteredLinks$ = combineLatest([this.filterText$.pipe(startWith('')), this.cms.getV2ContentByType$("Links")]).pipe(
            map(([filterText, data]) => {
                if (!filterText)
                    return this.groupItems(data);

                let filteredResults = data.filter(d => d.Title.toLowerCase().includes(filterText.toLowerCase())
                    || d.Summary?.toLowerCase()?.includes(filterText.toLowerCase()));

                return this.groupItems(filteredResults);
            })
        );

        this.links = new LoadingWrapper(this.filteredLinks$);
    }

    public ngOnDestroy() {
        this.log("ngOnDestroy", "", LogCategory.Destroy);
    }

    public ngAfterViewInit() {
        // See https://blog.angularindepth.com/everything-you-need-to-know-about-the-expressionchangedafterithasbeencheckederror-error-e3fd9ce7dbb4
        // Added after error handling template added to component.
        this.changeDetector.detectChanges();
    }

    private groupItems(data: any) {
        let retVal = {};

        for (let file of data) {
            const key = !!file.Category ? file.Category : 'Other';

            if (!retVal[key])
                retVal[key] = [];

            retVal[key].push(file);
        }
        return retVal;
    }

    public toggleGroups(expandType: string, links: any) {
        switch (expandType) {
            case 'collapse':
                this.isExpanded = [];
                break;
            case 'expand':
                Object.keys(links).forEach((key, index) => {
                    this.isExpanded.push(index);
                });

                break;
            case 'favorites':
                const favorites = this.profileService.profile.favorites;

                this.isExpanded = [];
                Object.keys(links)
                    .sort()
                    .forEach((key, index) => {
                        let foundFaves = links[key].some(l => favorites.includes(l.Id));

                        if (foundFaves)
                            this.isExpanded.push(index);
                    });
                break;

        }
    }

    public expandCollapse(index: number) {
        if (this.isExpanded.includes(index))
            this.isExpanded = this.isExpanded.filter(i => i != index);
        else
            this.isExpanded.push(index);
    }

    public updateFavorite(favorites, item) {


        //  Update the local variable so we don't have to re-fetch the whole profile
        //  after updating.
        const index = favorites.indexOf(item.Id);
        let isFave = true;
        if (index > -1) {
            favorites.splice(index, 1);
            isFave = false;
        }
        else
            favorites.push(item.Id);

        //We are recording favorites to google analytics
        this.gtm.gaLinkFave(this.profileService.labelLookup[this.data.meta.Name], item.Title, isFave);


        var data: ProfileSetting[] = [new ProfileSetting()]
        data[0].Id = ".Myke.Favorites";
        data[0].Type = "text";
        data[0].Value = item.Id;
        this.profileService.updateSettings(data, false);
    }

    public linkClicked(item) {
        this.gtm.gaLinkClicked(this.profileService.labelLookup[this.data.meta.Name], item.Title);
    }
}

